import { Injectable, computed, signal } from '@angular/core';
import { Capacitor } from '@capacitor/core';

export type AppPlatform = 'web' | 'android' | 'ios';

@Injectable({ providedIn: 'root' })
export class PlatformService {
  private readonly currentPlatform = signal<AppPlatform>(this.detectPlatform());

  readonly platform = computed(() => this.currentPlatform());
  readonly isWeb = computed(() => this.currentPlatform() === 'web');
  readonly isAndroid = computed(() => this.currentPlatform() === 'android');
  readonly isIos = computed(() => this.currentPlatform() === 'ios');
  readonly isNative = computed(() => Capacitor.isNativePlatform());

  private detectPlatform(): AppPlatform {
    const platform = Capacitor.getPlatform();

    if (platform === 'android' || platform === 'ios') {
      return platform;
    }

    return 'web';
  }
}
